<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <v-card height="100%">
      <v-toolbar dark color="blue">
        <v-toolbar-title>{{ esVideo ? 'Video' : 'Documento' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
      <!-- Mostrar video si es MP4 -->
      <div v-if="esVideo" style="height: calc(100% - 64px); display: flex; align-items: center; justify-content: center; background-color: #000;">
        <video :src="ruta" controls style="max-width: 100%; max-height: 100%;" controlsList="nodownload">
          Tu navegador no soporta la reproducción de videos.
        </video>
      </div>
      
      <!-- Mostrar PDF en iframe -->
      <iframe v-else :src="ruta" width="100%" :height="height" :name="iframeName"></iframe>
    </v-card>
  </v-dialog>
</template>

<script>
import pdf from "vue-pdf";

export default {
  data: (vm) => ({
    extension: ".pdf",
    ruta: "",
    height: "100%",
    esVideo: false,
  }),

  props: ["visible", "codigo", "nivel", "rutadoc", "rutaarchivo", "tipoArchivo"],

  computed: {
    show: {
      get() {

        if (this.codigo != "") {
          console.log(this.codigo)
          this.ruta =
            `https://api.icssa.com.ar/SGI/Documentos/${this.codigo}.pdf?${Math.random()}`;
          this.esVideo = false;
          // this.createIframe();
        }
        if (this.rutadoc != "") {
          // Detectar si es video o PDF
          const extension = this.tipoArchivo || 'pdf';
          this.esVideo = extension === 'mp4';
          
          this.ruta =
            `https://api.icssa.com.ar/capacitaciones/${this.rutadoc}.${extension}?${Math.random()}`;
          // this.createIframe();
        }
        // if (this.rutaarchivo != "") {
        //   this.ruta = `https://api.icssa.com.ar/protocolos/PDF/${this.rutaarchivo}.pdf?${Math.random()}`;
        //   // this.ruta =
        //   //   `file://192.168.11.2/backup/Calidad/protocolos/PDF/${this.rutaarchivo}.pdf?${Math.random()}`;
        //   // this.createIframe();
        // }
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    iframeName() {
      return `iframe-${this.codigo}`;
    }
  },
  methods: {
    createIframe() {
      const container = document.getElementById('iframe');
      if (container) {
        console.dir(container);
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', this.ruta);
        iframe.setAttribute('width', '100%');
        container.appendChild(iframe);
      }
    }
  },
  beforeDestroy() {
    this.ruta = null;
  }
};
</script>
